export default __webpack_public_path__ + "static/img-channel-thumbnail-first-581d07f42e143d62e19fb988547524cd.png";